import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export interface ArticleImageProps {
  imageUrl: string;
}

export const Item = styled.a`
  display: grid;
  position: relative;
  grid-template-columns: 25% 1fr;
  grid-column-gap: 10px;
  align-items: stretch;
  width: 100%;
  color: inherit;
  text-decoration: inherit;
  border: 1px solid var(--ogm-more-articles-border-color);
  border-radius: 5px;
  overflow: hidden;
  background-color: var(--ogm-white);
  color: var(--cxy-color-midnight-blue-600);
  font-family: var(--cxy-font-family-sans);
`;

export const TitleContainer = styled.div`
  padding: 9px 9px 9px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const imageContainer = css`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;

  & img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const Title = styled.div`
  font-size: var(--cxy-fontSize-m);
  font-style: normal;
  font-weight: var(--cxy-fontWeight-bold);
  line-height: var(--cxy-lineHeight-xs);
  letter-spacing: 0.14px;
  font-family: var(--cxy-font-family-sans);

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 37px;

  ${Item}:hover & {
    text-decoration: underline;
  }
`;

export const Author = styled.div`
  font-size: 12px;
  font-style: normal;
  font-weight: var(--cxy-fontWeight-medium);
  line-height: 150%;
  letter-spacing: 0.12px;
  font-family: var(--cxy-font-family-sans);
`;
export const FlexWrapper = styled.div`
  display: flex;
  margin-top: 8px;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 3px;
`;
export const PublishedDate = styled(Author)`
  color: #6b7883;
  font-family: var(--cxy-font-family-sans);
`;
export const ReadTime = styled(Author)``;
export const Description = styled.p`
  margin-top: 8px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: var(--cxy-font-family-sans);
`;
